import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import ComplexSettingsCard from '../../../components/cards/ComplexSettingsCard';
import { useComplexes } from '../../../hooks/useComplexes';
import { deleteComplex } from '../../../api/complexes';
import { COMMON_TRANSLATE_KEYS } from '../../../constants/translate-keys';

const MyFieldsTab = () => {
  const { complexes, getComplexes } = useComplexes();

  const { t } = useTranslation();

  const handleDeleteComplex = useCallback(
    async (complexId: number) => {
      const { data, error } = await deleteComplex(complexId);

      if (error) {
        toast(error.error.message, {
          toastId: 'delete-complex',
        });
        return;
      }

      if (data) {
        await getComplexes();
      }
    },
    [getComplexes]
  );

  const renderComplexCards = useCallback(() => {
    if (complexes.length === 0) {
      return <h3>{t(COMMON_TRANSLATE_KEYS.NO_COMPLEXES)}</h3>;
    }

    return (
      <div className="lg:max-w-[55rem] grid grid-cols-1 md:grid-cols-2 gap-4 w-full justify-items-center">
        {complexes.map((c) => (
          <ComplexSettingsCard
            key={c.id}
            complex={c}
            handleDeleteComplex={handleDeleteComplex}
          />
        ))}
      </div>
    );
  }, [complexes, handleDeleteComplex, t]);

  return (
    <div className="flex flex-row gap-4 my-4">
      {renderComplexCards()}
    </div>
  );
};

export default MyFieldsTab;
